module.exports = __webpack_public_path__ + "static/media/worldcom_pic.0eaf777c.svg";